import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { ContactAddressType } from '../../../../../../common/ContactAddress.type'
import useContactAddressCard from '../../../../../../hooks/useContactAddressCard'

type Props = {
  contactAddress: ContactAddressType
}

const FirstCardContent: FC<Props> = (props) => {
  const { contactAddress } = props
  const navigate = useNavigate()
  const { iconColor } = useContactAddressCard(contactAddress)

  return (
    <div className="switcher:short1">
      <span
        id="contactAddressName"
        className="contactAddress-name"
        onClick={() => navigate(`/contactAddress/${contactAddress.id}`)}
      >
        {contactAddress.lastName || contactAddress.firstName
          ? `${contactAddress.lastName ?? ''} ${contactAddress.firstName ?? ''}`.trim()
          : contactAddress.contactName
            ? contactAddress.contactName
            : ''}

        <br />
        {(contactAddress.lastNameKana || contactAddress.firstNameKana) && (
          <span className="text-small">
            {` ${contactAddress.lastNameKana ?? ''} ${contactAddress.firstNameKana ?? ''}`.trim()}
          </span>
        )}
      </span>

      <span
        id="contactType"
        className="badge text-tiny"
        style={{ backgroundColor: iconColor }}
      >
        {contactAddress.contactType === '010' && 'カンパニー内'}
      </span>
      <span
        id="contactCattegory"
        className="badge text-tiny"
        style={{ backgroundColor: iconColor }}
      >
        {contactAddress.category === 'shared' && '共有'}
      </span>

    </div>
  )
}

export default FirstCardContent
